import React from "react";
import { ExdWidgetSkeleton } from "./exdMui";

const WidgetSkeleton = () => <ExdWidgetSkeleton />;

export default WidgetSkeleton;
